export default __webpack_public_path__ + "static/media/litho-demo-split-portfolio.8bc6c2a1.jpg";